import { BackBar } from '../../components/BackBar'
import { EmbeddedDocFrame } from '../../components/EmbeddedDocFrame'
import { WebsiteHeader, WebsiteHeaderSpacer } from '../../components/WebsiteHeader'
import { useThemeColor } from '../../hooks/StatusBarColorPicker'
import { useI18n } from '../../i18n'

// The live Omnidek-hosted "MP - EDA Application of Interest" public form.
// Embedded in-page (iframe) so the prospect stays inside the app rather than
// being handed off to an external browser tab.
const APPLICATION_OF_INTEREST_URL =
  'https://innovateguyana.omnidek.com/public-form/8F2FAC6B-CE98-44B1-BEF1-FC873A5C5F9F/MP%20-%20EDA%20Application%20of%20Interest'

/**
 * Application of Interest screen — a drill-in page reached from the Home feature
 * card's "Complete Application" CTA. Standalone website shell (EDF website header +
 * BackBar, no bottom tab bar): a back-navigable detail page that frames the
 * externally-hosted application form as an embedded tile.
 */
export function ApplicationOfInterestScreen() {
  useThemeColor('#FFFFFF') // match the website header
  const { t } = useI18n()

  return (
    <div className="flex min-h-dvh flex-col bg-gray-50">
      <WebsiteHeader />
      <main className="flex min-h-dvh flex-1 flex-col">
        <WebsiteHeaderSpacer />
        {/* Omnidek scales the form to the iframe width (design is 1920px wide),
            so the phone column makes every field tiny on a desktop. */}
        <div className="mx-auto flex w-full max-w-screen-sm flex-1 flex-col md:max-w-[1440px]">
          <BackBar label={t('applicationOfInterest.title')} to="/home" />
          <EmbeddedDocFrame
            title={""}
            src={APPLICATION_OF_INTEREST_URL}
            fill="page"
            maskBottomBar
          />
        </div>
      </main>
    </div>
  )
}
